import React, { useState } from 'react'
import { customHeaders } from 'api/api'
import { useTranslation } from 'react-i18next'
import { RestApi } from '@node-space/rest-api'
import {
  AlignActions,
  Modal,
  ModalActions,
  ModalNavBar,
  SuccessContainer,
} from '@node-space/storybook-components'
import { logError } from '@node-space/utils'
import LoadingAnimationDark from 'components/spinners/LoadingAnimationDark'

interface DeleteBankAccountModalProps {
  accountId: string
  onClose: () => void
  onSuccess: () => void
}

export const DeleteBankAccountModal = ({
  accountId,
  onClose,
  onSuccess,
}: DeleteBankAccountModalProps) => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)

  const onAccept = async () => {
    setIsLoading(true)
    try {
      const response = await RestApi.del(true, `payment-method/${accountId}`, {}, customHeaders)
      if (response.status === 200) {
        setIsLoading(false)
        setShowSuccess(true)
      }
    } catch (error) {
      logError('Error from DeleteBankAccountModal - onAccept', error)
      setIsLoading(false)
    }
  }

  const onContinueClick = () => {
    setShowSuccess(false)
    onSuccess()
  }

  return (
    <Modal visible={!!accountId} closeOnBackgroundClick={false} closeModal={onClose}>
      {showSuccess ? (
        <>
          <SuccessContainer
            headline={t('bankAccount.deleteAccountSuccessMessageHeading')}
            description={t('bankAccount.deleteAccountSuccessMessageSubheading')}
          />
          <ModalActions
            actions={[
              {
                children: t('done'),
                onClick: onContinueClick,
              },
            ]}
            alignActions={AlignActions.CENTER}
          />
        </>
      ) : (
        <>
          <div className="min-w-full">
            <ModalNavBar title={t('confirmDeleteBankAccount')} onClose={onClose} />
          </div>
          {isLoading ? (
            <div className="flex justify-center py-8">{LoadingAnimationDark}</div>
          ) : (
            <>
              <div className="p-8">{t('areYouSureDeleteBankAccount')}</div>
              <ModalActions
                actions={[
                  {
                    children: t('cancel'),
                    secondary: true,
                    onClick: onClose,
                  },
                  {
                    children: t('continue'),
                    onClick: onAccept,
                  },
                ]}
              />
            </>
          )}
        </>
      )}
    </Modal>
  )
}
